import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import BaseFacet from '../BaseFacet/BaseFacet';
import FacetType from '../../../utility/types/facetType';
import { facetTypeDetails } from '../../../utility/types/facetTypeDetails';
import { store } from '../../../redux/store';

/* istanbul ignore next */
class NotificationTemplateFacet extends BaseFacet {
  constructor() {
    super();
    this.facetType = FacetType.ALERT_NOTIFICATION_TEMPLATES;
    this.displayName = 'Alert Notification Templates';
    this.description = 'includes...';
    this.storeState = store.getState();
  }

  getNotificationTemplateList() {
    return this.storeState.notificationTemplates.notificationTemplateList;
  }

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  getOperatorDescription(operatorType) {
    const operatorTypeId = parseInt(operatorType, 10);
    const operatorDescriptions = {
      [OperatorTypes.EQUAL_TO_VALUE]: 'ANY of the following:',
      [OperatorTypes.EQUAL_TO_BOOLEAN]: 'ALL of the following:',
      [OperatorTypes.NOT_EQUAL_TO]: 'NONE of the following',
    };
    return operatorDescriptions[operatorTypeId] || '';
  }

  getName() {
    return this.displayName;
  }

  getDescription() {
    return this.description;
  }

  // eslint-disable-next-line class-methods-use-this
  getDisplayValue1(value) {
    const matchedTemplate = this.getNotificationTemplateList()
      .find((template) => template.id === parseInt(value, 10));
    return matchedTemplate ? matchedTemplate.name : '';
  }

  /* istanbul ignore next */
  // eslint-disable-next-line class-methods-use-this
  getValueSelectOptions(templateList) {
    return templateList.map((template) => ({
      label: template.name,
      value: template.id.toString(),
    })).sort((a, b) => {
      const nameA = a.label.toUpperCase();
      const nameB = b.label.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  }

  getOperatorSelectOptions() {
    const facet = facetTypeDetails[this.facetType];
    return [
      {
        value: facet.validOperators[0],
        label: this.getOperatorDescription(facet.validOperators[0]),
      },
      {
        value: facet.validOperators[1],
        label: this.getOperatorDescription(facet.validOperators[1]),
      },
    ];
  }

  // eslint-disable-next-line class-methods-use-this
  getTooltip(filtersByOperatorObj) {
    return `Alert Notification Templates include ${
      filtersByOperatorObj[OperatorTypes.EQUAL_TO_VALUE]
        ? `ANY of ${filtersByOperatorObj[OperatorTypes.EQUAL_TO_VALUE]
          .map((filter) => this.getDisplayValue1(filter.value1))
          .join(', ')
        };`
        : ''
    }${
      filtersByOperatorObj[OperatorTypes.EQUAL_TO_BOOLEAN]
        ? ` ALL of ${filtersByOperatorObj[OperatorTypes.EQUAL_TO_BOOLEAN]
          .map((filter) => this.getDisplayValue1(filter.value1))
          .join(', ')
        };`
        : ''
    }${
      filtersByOperatorObj[OperatorTypes.NOT_EQUAL_TO]
        ? ` NONE of ${filtersByOperatorObj[OperatorTypes.NOT_EQUAL_TO]
          .map((filter) => this.getDisplayValue1(filter.value1))
          .join(', ')
        };`
        : ''
    }`;
  }
}
export default NotificationTemplateFacet;
